import { setGeoRedirect, Status } from 'storage/geo'
import { buildRegionSwitchSearch } from 'lib/url/searchUrlUtils'

export function switchRegion(regionCode: string) {
  if (!regionCode) return
  setGeoRedirect(Status.redirected)
  const newPath = window.location.pathname.replace(/^\/[a-z]+/, '/' + regionCode.toLowerCase())
  window.location.href = newPath + buildRegionSwitchSearch(window.location.search)
}

export default switchRegion
